<template>
  <div v-if="error" class="alert alert-danger" role="alert">
    <i class="fa-solid fa-circle-exclamation me-2"></i>
    {{ error }}
  </div>
</template>

<script setup>
defineProps({
  error: String
});
</script>

<style scoped>
.alert {
  border-radius: 8px;
  font-size: 0.9rem;
}
</style>
